import Vue from 'vue';
import SearchPanel from './SearchPanel';
import SearchCompetitionDataTable from './SearchCompetitionDataTable';

export default Vue.extend({
  props: {
    searchText: String,
    activator: String,
    sportId: Number,
    categoryId: Number,
  },

  render() {
    return (
      <SearchPanel activator={this.activator}>
        <SearchCompetitionDataTable
          searchText={this.searchText}
          sportId={this.sportId}
          categoryId={this.categoryId} />
      </SearchPanel>
    );
  },
});
